import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
import {
  getHoneycombRailHexColour,
  getRollerHexColour,
} from '../../../../../helpers/getHexColorCode';
import { getPatternImages } from '../../../../../helpers/getPatternImages';
import { getProductType } from '../../../../../helpers/getProductType';

export const CordedImage = (props: React.SVGProps<SVGSVGElement>) => {
  const [state] = useService(productBuilderMachine);
  const patternUrl = getPatternImages(state);
  const productType = getProductType(state.context);

  let cordColourHex = '#fff';
  if (productType && productType.includes('Honeycomb')) {
    const railColour = state.context.custom.railColour
      ? state.context.custom.railColour
      : 'Silver';
    cordColourHex = getHoneycombRailHexColour(railColour);
  }

  if (productType && productType.includes('Roller')) {
    const bracketColour = state.context.custom.bracketColour
      ? state.context.custom.bracketColour
      : 'Silver';

    cordColourHex = getRollerHexColour(bracketColour);
  }

  if (productType && productType.includes('Venetian')) {
    cordColourHex = 'url(#cordColour)';
  }

  if (productType && productType.includes('Honeycomb')) {
    return (
      <svg
        id="prefix__Layer_1"
        data-name="Layer 1"
        viewBox="0 0 9.67 456.95"
        {...props}
        preserveAspectRatio="none"
      >
        <defs>
          <style>
            {
              '.prefix__cls-2{fill:gray}.prefix__cls-3{fill:#e0e0e0;opacity:.75}'
            }
          </style>
        </defs>
        <rect
          x={3.33}
          width={3}
          height={437.51}
          rx={1}
          fill="#fff"
          opacity={0.5}
        />
        <path d="M4.34 1h1v435.51h-1z" />
        <path
          className="prefix__cls-2"
          d="M.69 436.28H9a.69.69 0 01.69.69v2.53H0V437a.69.69 0 01.69-.69z"
        />
        <path
          className="prefix__cls-3"
          d="M0 439.5h9.67v17.45H0zM.69 125.45H9a.69.69 0 01.69.69v2.53H0v-2.53a.69.69 0 01.69-.69z"
        />
        <path className="prefix__cls-2" d="M0 128.68h9.67v17.45H0z" />
      </svg>
    );
  } else if (productType && productType.includes('Venetian')) {
    return (
      <svg
        data-name="Layer 1"
        viewBox="0 0 18.41 458.19"
        {...props}
        preserveAspectRatio="none"
      >
        <defs>
          <pattern
            id="prefix__cord"
            data-name="Unnamed Pattern"
            width={135}
            height={135}
            patternTransform="translate(-6.39 -220.42)"
            patternUnits="userSpaceOnUse"
          >
            <path fill="none" d="M0 0h135v135H0z" />
            <image
              width={135}
              height={135}
              xlinkHref="data:image/jpeg;base64,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"
            />
          </pattern>
        </defs>
        <path
          d="M17.48 288.54a1.69 1.69 0 00-1.69-1.69h-1.65V1.24a1 1 0 00-1-1h-1a1 1 0 00-1 1v285.61H9.49a1.68 1.68 0 00-1.68 1.65L7.27 301V1a1 1 0 00-1-1h-1a1 1 0 00-1 1v431.14H2.63a1.69 1.69 0 00-1.69 1.65L0 455.68a2.41 2.41 0 002.4 2.51h6.75a2.41 2.41 0 002.4-2.51l-.94-21.85a1.69 1.69 0 00-1.69-1.69H7.27V311.83a3.75 3.75 0 00.26.33 2.43 2.43 0 001.74.74H16a2.39 2.39 0 002.39-2.5z"
          fill="#fff"
          opacity={0.5}
        />
        <path
          d="M17.41 310.44A1.4 1.4 0 0116 311.9H9.27a1.4 1.4 0 01-1.4-1.46l.94-21.9a.68.68 0 01.68-.69h2.65V1.24h1v286.61h2.65a.69.69 0 01.69.69zm-8.49 122.7H6.27V1.24h-1v431.9H2.63a.69.69 0 00-.69.69L1 455.73a1.41 1.41 0 001.4 1.46h6.75a1.41 1.41 0 001.4-1.46l-.94-21.9a.69.69 0 00-.69-.69z"
          fill="url(#prefix__cord)"
        />
        <g opacity={0.25}>
          <path d="M16.48 288.54a.69.69 0 00-.69-.69h-2.65V1.24h-1v286.61H9.49a.68.68 0 00-.68.69l-.94 21.9a1.4 1.4 0 001.4 1.46H16a1.4 1.4 0 001.39-1.46z" />
          <path d="M8.92 433.14H6.27V1h-1v432.14H2.63a.69.69 0 00-.69.69L1 455.73a1.41 1.41 0 001.4 1.46h6.75a1.41 1.41 0 001.4-1.46l-.94-21.9a.69.69 0 00-.69-.69z" />
        </g>
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="prefix__Layer_1"
        x={0}
        y={0}
        viewBox="0 0 19 213.9"
        xmlSpace="preserve"
        preserveAspectRatio="none"
        {...props}
      >
        <defs>
          <pattern
            id="cordColour"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patternUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <style>
          {`.prefix__st0{opacity:.5;fill:#fff}.prefix__st1{fill:${cordColourHex}}.prefix__st2{opacity:.25}`}
        </style>
        <path
          className="prefix__st0"
          d="M.8 213.9c-.4 0-.8-.3-.8-.8v-16.6c0-2.5 1.9-4.6 4.3-4.8V.8c0-.5.4-.8.8-.8h1c.4 0 .8.3.8.8v191c2.4.3 4.3 2.3 4.3 4.8v16.6c0 .4-.3.8-.8.8H.8z"
        />
        <path
          className="prefix__st0"
          d="M8.6 162.4c-.4 0-.8-.3-.8-.8V145c0-2.5 1.9-4.6 4.3-4.8V.8c.1-.5.4-.8.9-.8h1c.4 0 .8.3.8.8v139.5c2.4.3 4.3 2.3 4.3 4.8v16.6c0 .4-.3.8-.8.8H8.6z"
        />
        <path
          className="prefix__st1"
          d="M6.3 192.5h-.2V.8h-1v191.8h-.3c-2.3 0-4.1 1.8-4.1 4.1v16.6h9.7v-16.6c0-2.4-1.8-4.2-4.1-4.2z"
        />
        <path
          className="prefix__st1"
          d="M14.2 141H14V.8h-1V141h-.2c-2.3 0-4.1 1.8-4.1 4.1v16.6h9.7V145c-.1-2.2-1.9-4-4.2-4z"
        />
        <path
          className="prefix__st2"
          d="M6.3 192.5h-.2V.8h-1v191.8h-.3c-2.3 0-4.1 1.8-4.1 4.1v16.6h9.7v-16.6c0-2.4-1.8-4.2-4.1-4.2z"
        />
        <path
          className="prefix__st2"
          d="M14.2 141H14V.8h-1V141h-.2c-2.3 0-4.1 1.8-4.1 4.1v16.6h9.7V145c-.1-2.2-1.9-4-4.2-4z"
        />
      </svg>
    );
  }
};
